<template lang="pug">
.send-message-example-modal
  b-modal(ref="modal" size="xl" no-close-on-backdrop no-close-on-esc hide-footer scrollable)
    .send-message-example-modal-header(slot="modal-header" slot-scope="{ cancel }")
      .float-left.title
        span メッセージ送信の使用例
      .float-right
        button(type="button" class="close" @click="cancel()") ×
    .send-message-example-modal-body
      .title ご家族への連絡
      .note
        span コロナ禍で
        span.keyword 施設の状況・ご利用者の様子
        span が分からず不安なご家族に
        span.keyword 情報共有
        span することで、ご家族の
        span.keyword 安心感
        span が高まります。
      ul.detail-text
        li
          span 面会制限のお知らせ等、ご家族全員への
          span.keyword 一斉連絡
        li
          span イベント時の
          span.keyword 写真
          span 、日常生活の
          span.keyword 動画
          span 等、
          span.keyword 個別のご家族
          span への連絡
        li
          span 保険証の提出依頼、季節の変わり目での衣服の依頼等、
          span.keyword ご家族への依頼
      b-img.image(src="@/assets/send-message-example-family.png" fluid)
      .title 職員への連絡
      .note
        span 掲示板掲載やメール連絡だと職員が
        span.keyword 見たかどうか分からない
        span 、職員のプライベート
        span.keyword LINEを交換するのは難しい
        span 、という課題があります。
        br
        span HitomeQコネクトの職員連絡は、
        span.keyword 一斉連絡・既読確認
        span が出来ます。また職員の
        span.keyword LINEプロフィールを公開することなく使用
        span できます。
      ul.detail-text
        li
          span.keyword 施設ルールの徹底
          span 、新規導入機器の運用ルール連絡等、職員連絡と
          span.keyword 既読確認
        li
          span ヒヤリハット
          span.keyword 報告書等の回覧と既読確認
        li
          span BCP対策（事業継続対策）として、
          span.keyword 緊急時の連絡網
      b-img.image(src="@/assets/send-message-example-otheruser.png" fluid)
</template>

<script lang="ts">
import { Component, Vue } from "vue-property-decorator";

/**
 * メッセージ送信の使用例モーダル
 */
@Component
export default class SendMessageExampleModal extends Vue {
  /**
   * モーダル表示
   */
  public show(): void {
    const modal: any = this.$refs.modal;
    if (modal) {
      modal.show();
    }

    return;
  }
}
</script>
